module.exports = __webpack_public_path__ + "img/Upload_record-B.dbd7fa86.svg";